import { withTranslation } from "react-i18next";
import GeneralInfo from './GeneralInfo';

export default withTranslation()(GeneralInfo);